import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomErrorStateMatcher } from '../../models/custom-error-state';
import { map, Observable, startWith } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-address-editor',
  templateUrl: './address-editor.component.html',
  styleUrls: ['./address-editor.component.scss']
})
export class AddressEditorComponent implements OnInit {
    @Input() addressForm: FormGroup
    @Input() countries: any[] = [];
    @Output() countryUpdated = new EventEmitter<any>();
    filteredCountries: Observable<any[]>;

    errorMatcher = new CustomErrorStateMatcher();

    constructor() { }

    get f() { return this.addressForm.controls; }
    ngOnInit() {
        this.filteredCountries = this.addressForm.controls['country'].valueChanges
        .pipe(
            startWith(''),
            map(value => this._filter(value))
        );
    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();

        return this.countries.filter(option => option.name.toLowerCase().includes(filterValue));
    }

    countryBlur() {
        console.log("Country form element blur event");
        this.countryUpdated.emit(this.addressForm);
    }
}
